const getPageIdFromUserId = (userMap = []) => (userId) =>
  Number(Object.keys(userMap).find((user) => userMap[user] === userId)) || 0

export default getPageIdFromUserId
